/**
 * 日報管理ページ用のスクリプト
 */
if (is_route('drive_operation.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        drive_operation_event_set();
    });
}
if (is_route('drive_operation.setting_index') || is_route('drive_operation.detail_index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        drive_operation_setting_event_set();
    });
}
if (is_route('drive_operation.shipper_index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        drive_operation_shipper_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.drive_operation_event_set = function () {

    /*---- 検索条件変更時 ----*/

    // 入力日時（開始）変更時
    $(document).on('change', '#search-form-end_time_from', function () {
        let last_day = null;
        selected_date = $(this).val();
        set_end = $('#search-form-end_time_to').val();
        if(set_end != ''){
            selected_date = new Date(selected_date);
            chk_date_over = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31);
            chk_date = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate());
            set_end = new Date(set_end);
            yyyymmdd = new Date(set_end.getFullYear(),set_end.getMonth(),set_end.getDate());
            if(chk_date_over.getTime() < yyyymmdd.getTime()){
                yyyymmdd = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31);
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0"+( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd.getDate() ).slice(-2);
                $('#search-form-end_time_to').val(last_day);
            }else if(chk_date.getTime() > yyyymmdd.getTime()){
                last_day = chk_date.getFullYear()+'/'+
                        ( "0"+( chk_date.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+chk_date.getDate() ).slice(-2);
                $('#search-form-end_time_to').val(last_day);
            }
        }
    });

    // 入力日時（終了）変更時
    $(document).on('change', '#search-form-end_time_to', function () {
        let last_day = null;
        selected_date = $(this).val();
        set_start = $('#search-form-end_time_from').val();
        if(set_start != ''){
            selected_date = new Date(selected_date);
            set_start = new Date(set_start);
            yyyymmdd = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate() + 31);
            yyyymmdd_2 = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate());
            if(selected_date.getTime() > yyyymmdd.getTime()){
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0"+( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd.getDate() ).slice(-2);
                $('#search-form-end_time_to').val(last_day);
            }else if(selected_date.getTime() < yyyymmdd_2.getTime()){
                last_day = yyyymmdd_2.getFullYear()+'/'+
                        ( "0"+( yyyymmdd_2.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd_2.getDate() ).slice(-2);
                $('#search-form-end_time_to').val(last_day);
            }
        }
    });

    /*---- 一括削除チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#drive_operation-all-check', function () {
        $(".drive_operation-check").prop('checked', $(this).prop('checked'));
    });

    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#drive_operation-all-check, .drive_operation-check', function () {
        // 一覧のチェック状態を判定し削除ボタンを有効化
        $('#search-form-action_download').prop('disabled', ($('.drive_operation-check:checked').length == 0));
    });

    /*---- CSVダウンロード時 ----*/

    // CSVダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // basic_idsの初期化
        let ids = [];
        // 検索フォームを配列化
        let data = $('#search-form').serializeArray();
        // チェックされていない場合はスキップ
        if($('.drive_operation-check:checked').val() == null) {
            return false;
        }
        // basic_ids取得
        $('.drive_operation-check:checked').map(function () {
            ids.push($(this).val());
        });
        data.push({'name' : 'basic_ids', 'value' : ids});
        // ポスト送信を実行
        post(action, data);
    });

    // TRIO download button click handler
    $(document).on('click', '#search-form-action_trio_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // basic_idsの初期化
        let ids = [];
        // 検索フォームを配列化
        let data = $('#search-form').serializeArray();
        // チェックされていない場合はスキップ
        if($('.drive_operation-check:checked').val() == null) {
            return false;
        }
        // basic_ids取得
        $('.drive_operation-check:checked').map(function () {
            ids.push($(this).val());
        });
        data.push({'name' : 'basic_ids', 'value' : ids});
        
        const $button = $(this);
        $.ajax({
            url: action,
            method: 'POST',
            data: data,
            xhrFields: {
                responseType: 'blob'
            },
            success: function(blob, status, xhr) {
                const contentType = xhr.getResponseHeader('Content-Type');
                
                if (contentType && 
                    (contentType.includes('application/zip') || 
                        contentType.includes('application/octet-stream'))) {
                    
                    let filename = 'trio_files.zip';
                    const disposition = xhr.getResponseHeader('Content-Disposition');
                    if (disposition && disposition.includes('filename=')) {
                        filename = decodeURIComponent(
                            disposition.split('filename=')[1].replace(/['"]/g, '').trim()
                        );
                    }
                    
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    URL.revokeObjectURL(url);
                }
            },
            error: function(xhr) {
                toastr.error($button.data('error'));
            }
        });
        
    });

    /*---- 設定/日報印刷の表示時 ----*/

    // 設定/日報印刷 表示時
    $(document).on('click', '#drive_operation-search-form-action_setting, #drive_operation-search-form-action_report, #drive_operation-search-form-action_detail', function () {
        let self = $(this);
        // 検索条件を配列化
        let params = ['id', 'holding_id', 'company_id', 'section_id', 'record_id', 'start_time', 'end_time', 'end_time_from', 'end_time_to', 'driver_code', 'driver_id', 'vehicle_code', 'vehicle_id', 'report_number', 'search_type', 'filter_holding_id', 'filter_company_id', 'filter_section_id'];
        let data = [];
        // データを追加
        params.forEach(function(param) {
            if (self.data(param) != null && self.data(param) != '' ) {
                data.push({'name' : param, 'value' : self.data(param)});
            }
        });
        // アクション取得
        action = self.data('action');
        url = _request.create_url(action, data);
        // 生成したURLへリダイレクト
        location.href = url;
    });

    /*---- 日報出力ボタン押下時 ----*/

    // 日報出力ボタン押下時
    $(document).on('click', '#drive_operation-search-form-printing_report', function () {
        // 検索フォームを配列化
        let data = [];
        // データを追加
        data.push({'name' : 'holding_id', 'value' : $(this).data('holding_id')});
        data.push({'name' : 'company_id', 'value' : $(this).data('company_id')});
        data.push({'name' : 'section_id', 'value' : $(this).data('section_id')});
        data.push({'name' : 'record_id', 'value' : $(this).data('record_id')});
        data.push({'name' : 'start_time', 'value' : $(this).data('start_time')});
        data.push({'name' : 'end_time', 'value' : $(this).data('end_time')});
        // 運転日報ボタンからは固定でパラメーターを送信する
        data.push({'name' : 'report_type', 'value' : 'drive_report'});
        // BlobでPDFを別ウィンドウで表示
        _ajax.blob($(this).data('action'), data, function (blob) {
            window.open(window.URL.createObjectURL(blob), '_blank');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 削除確認の表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-confirm-modal]', function () {
        // 設定モーダルを表示
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal', function(results) {
            // ツールバーの更新が必要なのでリロードする
            location.reload();
        });
    });

       // 解析依頼ボタン押下時
    $(document).on('click', '#navitime_diagnosis_button', function () {
        let action = $(this).data('action');
        let data = [];
        // データを追加
        data.push({'name' : 'id', 'value' : $(this).data('id')});
        data.push({'name' : 'holding_id', 'value' : $(this).data('holding_id')});
        // 送信前にエラーをリセット
        _error.reset()
        if (confirm("解析依頼を行いますがよろしいですか？")) {
            _ajax.post(action, data, function (results) {
                // 完了メッセージをセットする
                _complete.set(results);
                // コンテンツの読込
                load_contents();
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }
    });
}

/**
 * 日報修正表示時のイベント設定
 */
window.drive_operation_setting_event_set = function() {

    /*---- 印刷ボタン押下時 ----*/

    // 印刷ボタン押下時
    $(document).on('click', '#drive_operation-search-form-printing_report', function () {
        // 検索フォームを配列化
        let data = [];
        // report_typeを取得
        report_type = $('input:radio[name="report_type"]:checked').val();
        // 温度記録
        ch1 = $('input:checkbox[name="chart1_ch1"]:checked').val();
        ch2 = $('input:checkbox[name="chart1_ch2"]:checked').val();

        // データを追加
        data.push({'name' : 'id', 'value' : $(this).data('id')});
        data.push({'name' : 'holding_id', 'value' : $(this).data('holding_id')});
        data.push({'name' : 'company_id', 'value' : $(this).data('company_id')});
        data.push({'name' : 'section_id', 'value' : $(this).data('section_id')});
        data.push({'name' : 'record_id', 'value' : $(this).data('record_id')});
        data.push({'name' : 'start_time', 'value' : $(this).data('time_from')});
        data.push({'name' : 'end_time', 'value' : $(this).data('time_to')});
        data.push({'name' : 'report_format', 'value' : $(this).data('report_format')});
        data.push({'name' : 'report_type', 'value' : report_type});
        data.push({'name' : 'chart1_ch1', 'value' : ch1});
        data.push({'name' : 'chart1_ch2', 'value' : ch2});

        // BlobでPDFを別ウィンドウで表示
        _ajax.blob($(this).data('action'), data, function (blob) {
            window.open(window.URL.createObjectURL(blob), '_blank');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- 理由登録ボタン押下時 ----*/

    // 理由登録ボタン押下時
    $(document).on('click', '#drive_operation-report-form-shipper', function () {
        // データを追加
        let data = [];
        data.push({'name' : 'id', 'value' : $(this).data('id')});
        data.push({'name' : 'holding_id', 'value' : $(this).data('holding_id')});
        data.push({'name' : 'company_id', 'value' : $(this).data('company_id')});
        data.push({'name' : 'section_id', 'value' : $(this).data('section_id')});
        data.push({'name' : 'record_id', 'value' : $(this).data('record_id')});
        data.push({'name' : 'start_time', 'value' : $(this).data('start_time')});
        data.push({'name' : 'end_time', 'value' : $(this).data('end_time')});
        data.push({'name' : 'end_time_from', 'value' : $(this).data('end_time_from')});
        data.push({'name' : 'end_time_to', 'value' : $(this).data('end_time_to')});
        data.push({'name' : 'filter_holding_id', 'value' : $(this).data('filter_holding_id')});
        data.push({'name' : 'filter_company_id', 'value' : $(this).data('filter_company_id')});
        data.push({'name' : 'filter_section_id', 'value' : $(this).data('filter_section_id')});
        // アクションの取得
        let action = $(this).data('action');
        url = _request.create_url(action, data);
        // 生成したURLへリダイレクト
        location.href = url;
    });

    /*---- 編集/日報修正の表示時 ----*/

    // 編集/日報修正 表示時
    $(document).on('click', '#drive_operation-search-form-action_setting', function () {
        let self = $(this);
        // 検索条件を配列化
        let params = ['id', 'holding_id', 'company_id', 'section_id', 'record_id', 'start_time', 'end_time', 'end_time_from', 'end_time_to', 'driver_code', 'driver_id', 'vehicle_code', 'vehicle_id', 'report_number', 'filter_holding_id', 'filter_company_id', 'filter_section_id'];
        let data = [];
        // データを追加
        params.forEach(function(param) {
            if (self.data(param) != null && self.data(param) != '' ) {
                data.push({'name' : param, 'value' : self.data(param)});
            }
        });
        // アクション取得
        action = self.data('action');
        url = _request.create_url(action, data);
        // 生成したURLへリダイレクト
        location.href = url;
    });

    /*---- 乗務員変更時 ----*/

    // 乗務員変更時
    $(document).on('click', '[data-driver-setting-modal]', function () {
        _modal.create(this, 'driver-setting-modal', ['holding_id', 'company_id', 'section_id', 'record_id']);
    });

    /*---- 同乗者変更時 ----*/

    // 同乗者変更時
    $(document).on('click', '[data-passenger-setting-modal]', function () {
        _modal.create(this, 'passenger-setting-modal', ['holding_id', 'company_id', 'section_id', 'record_id']);
    });

    /*---- 荷主変更時 ----*/

    // 荷主変更時
    $(document).on('click', '[data-shipper-setting-modal]', function () {
        _modal.create(this, 'shipper-setting-modal', ['holding_id', 'company_id', 'section_id', 'record_id']);
    });

    /*---- 作業 - 編集ボタン ----*/

    // 作業 - 編集ボタン
    $(document).on('click', '[data-work-setting-modal]', function () {
        _modal.create(this, 'work-setting-modal', ['id', 'summary_id'], false, function () {
            // 初期表示設定
            $('#drive_operation-work-setting-modal-time_required_0').prop('disabled', true);
        });
    });

    /*---- 作業 - 行先登録ボタン ----*/

    // 作業 - 行先登録ボタン
    $(document).on('click', '[data-loading_point-setting-modal]', function () {
        _modal.create(this, 'loading_point-setting-modal', ['id', 'out_mode', 'holding_id', 'company_id', 'type', 'destination_type', 'name', 'zipcode', 'prefecture', 'municipality', 'address', 'phone_number', 'latitude', 'longitude'], false, function(){
            loading_point_setting_event_set();
        });
    });

    /*---- 通行料 - 追加ボタン ----*/

    // 通行料 - 追加ボタン
    $(document).on('click', '[data-toll-setting-modal]', function () {
        _modal.create(this, 'toll-setting-modal', ['id', 'summary_id', 'holding_id', 'company_id', 'section_id', 'start_time', 'end_time', 'is_inputed']);
    });

    /*---- 給油 - 追加ボタン ----*/

    // 給油 - 追加ボタン
    $(document).on('click', '[data-oil-setting-modal]', function () {
        _modal.create(this, 'oil-setting-modal', ['id', 'summary_id', 'record_id', 'holding_id', 'company_id', 'section_id', 'start_time', 'end_time']);
    });

    /*---- 設定の保存時 ----*/

    // 設定実行時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 削除確認の表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-confirm-modal]', function () {
        // 設定モーダルを表示
        _modal.create(this, 'confirm-modal', ['id', 'summary_id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    /*---- 動画要求時 ----*/

    // 動画要求時
    $(document).on('click', '[data-request-video-save-modal]', function () {
        _modal.submit(this, 'request-video-save-modal');
    });

    /*---- イベント切替時 ----*/

    // イベント切替時
    $(document).on('click', '.nav-link', function() {
        var search_type = $(this).data('search_type');
        if(search_type == 'toll-search') {
            $('#div_toll').removeClass('display-none');
        }else {
            $('#div_toll').addClass('display-none');
        }
        if(search_type == 'oil-search') {
            $('#div_oil').removeClass('display-none');
        }else {
            $('#div_oil').addClass('display-none');
        }
    });

    /*---- 一覧に戻るボタン押下時 ----*/

    // 一覧に戻るボタン押下時
    $(document).on('click', '#drive_operation-list-button', function () {
        let self = $(this);
        // 検索条件を配列化
        let params = ['holding_id', 'company_id', 'section_id', 'end_time_from', 'end_time_to', 'type', 'driver_code', 'driver_id', 'vehicle_code', 'vehicle_id', 'report_number'];
        let data = [];
        // データを追加
        params.forEach(function(param) {
            if (self.data(param) != null && self.data(param) != '' ) {
                data.push({'name' : param, 'value' : self.data(param)});
            }
        });
        // アクション取得
        action = self.data('action');
        url = _request.create_url(action, data);
        // 生成したURLへリダイレクト
        location.href = url;
    });

    /*---- 動画要求ボタン押下時 ----*/

    // 動画要求ボタン押下時
    $(document).on('click', '[data-request-video-modal]', function () {
        // パラメタ編集
        let params = [];
        params.push({'name' : 'holding_id', 'value' : $(this).data('holding_id')});
        params.push({'name' : 'company_id', 'value' : $(this).data('company_id')});
        params.push({'name' : 'section_id', 'value' : $(this).data('section_id')});
        params.push({'name' : 'vehicle_id', 'value' : $(this).data('vehicle_id')});
        params.push({'name' : 'request_video_time', 'value' : $(this).data('request_video_time')});
        _modal.create_with_data(this, 'request-video-modal', params, true, null);
    });

    /*---- 動画再生ボタン押下時 ----*/

    // 動画再生ボタン押下時
    $(document).on('click', '[data-video-modal]', function () {
        // パラメタ編集
        let params = [];
        params.push({'name' : 'unit', 'value' : $(this).data('unit')});
        params.push({'name' : 'holding_id', 'value' : $(this).data('holding_id')});
        params.push({'name' : 'warning_id', 'value' : $(this).data('warning_id')});
        params.push({'name' : 'record_id', 'value' : $(this).data('record_id')});
        _modal.create_with_data(this, 'video-modal', params, true, function() {
            /** 動画再生用Viewer初期化 */
            record_data_modal_event_set();
        });
    });

    /*---- 作業情報登録の追加ボタンを押下(資格入力項目を追加する) ----*/

    $(document).on('click', '#edit-work button[name="add_work"]', function(){
        var count = $('#edit-work .card').length;
        var card = $('#edit-work .card:first').clone();
        var modalId = '#drive_operation-work-setting-modal';

        // 追加要素の初期化
        card.find('input,select').each(function() {
            $(this).val('');
            // id属性がセットされていない場合はスキップ
            if(!($(this).attr('id'))) {
                return true;
            }
            var id = $(this).attr('id');
            var newId = id.replace(/_0/g , '_' + count);
            var label = card.find('label[for="' + id + '"]');
            var error = card.find('#' + id + '-errors');

            // ID書き換え
            $(this).attr('id', newId);
            label.attr('for', newId);

            // data-id属性がセットされている場合は書き変え
            if($(this).attr('data-id')) {
                newDataId = $(this).attr('data-id').replace(/_0/g , '_' + count);
                $(this).attr('data-id', newDataId);
            }

            // error初期化
            if (error.length > 0) {
                error.attr('id', newId + '-errors');
                error.find('span').html('');
            }

            // Nameがnullの時はスキップ
            if(!($(this).attr('name'))) {
                return true;
            }

            // Name書き換え
            $(this).attr('name', $(this).attr('name').replace('[0]', '['+count+']'));

            // 初期値クリア
            // $(this).attr('data-old', '');
        });

        // 前イベントの終了日時を取得
        prevEndDate = $(modalId + '-end_date_' + (count - 1)).val();
        // 新カードの初期値を設定
        card.find('select[name="work_division[]"]').val("EV06030008");
        card.find('input[name="start_date[]"]').val(prevEndDate);
        card.find('input[name="end_date[]"]').val(prevEndDate);
        card.find(modalId + '-time_required_' + count).val("00:00");
        card.find(modalId + '-time_required_' + count + '-value').val("00:00");
        // Name書き換え
        card.find(modalId + '-time_required_' + count + '-value').attr('name', card.find(modalId + '-time_required_' + count + '-value').attr('name').replace('[0]', '['+count+']'));
        // 前イベントの所要時間を活性化
        $(modalId + '-time_required_' + (count - 1)).prop('disabled', false);
        // 所要時間(00:00)は非活性
        card.find(modalId + '-time_required_' + count).prop('disabled', true);
        // checkbox,radioの初期値がクリアされてしまうため再設定
        card.find('.load_in').val(1);
        card.find('.ferry_check').val(1)
        card.find('.futai_select_type1').val(0);
        card.find('.futai_select_type2').val(1);

        // 最後に追加
        card.insertAfter('#edit-work .card:last');
        // 追加後にイベント発火
        card.find('select[name="work_division[]"]').trigger('change');

        initialize();

        // 20件になったら追加ボタン殺す
        if (count + 1 >= 20) {
            $(this).prop('disabled', true);
        }
    });

    /*---- 作業区分変更時 ----*/

    // 作業区分変更時
    $(document).on('change', 'select[name="work_division[]"]', function() {
        // チェックボックスとラジオボタンの要素を取得
        loadIn = $(this).parent().find('.load_in');
        futaiType = $(this).parent().find('.futai_type');
        ferryCheck = $(this).parent().find('.ferry_check');

        // TODO:荷卸はついててて欲しい
        // 値をクリアして非表示
        switch($(this).val()) {
            case 'EV06030008': // 荷積or荷卸
            case 'EV06040008':
                loadIn.removeClass('display-none'); 
                $(this).parent().find('input.futai_select_type1').prop('checked', false);
                $(this).parent().find('input.futai_select_type2').prop('checked', false);
                futaiType.addClass('display-none');
                $(this).parent().find('input.ferry_check').prop('checked', false);
                ferryCheck.addClass('display-none');
                break;
            case 'EV60001901': // 付帯作業
                $(this).parent().find('input.load_in').prop('checked', false);
                loadIn.addClass('display-none');
                // TODO:値を見てデフォルトにチェックをつける
                $(this).parent().find('input.futai_select_type1').prop('checked', true);
                futaiType.removeClass('display-none');
                $(this).parent().find('input.ferry_check').prop('checked', false);
                ferryCheck.addClass('display-none');
                break;
            case 'EV06080008': // 乗船
                $(this).parent().find('input.load_in').prop('checked', false);
                loadIn.addClass('display-none');
                $(this).parent().find('input.futai_select_type1').prop('checked', false);
                $(this).parent().find('input.futai_select_type2').prop('checked', false);
                futaiType.addClass('display-none');
                ferryCheck.removeClass('display-none');
                break;
            default:
                $(this).parent().find('input.load_in').prop('checked', false);
                loadIn.addClass('display-none');
                $(this).parent().find('input.futai_select_type1').prop('checked', false);
                $(this).parent().find('input.futai_select_type2').prop('checked', false);
                futaiType.addClass('display-none');
                $(this).parent().find('input.ferry_check').prop('checked', false);
                ferryCheck.addClass('display-none');
        }
    });

    /*---- 所要時間変更時 ----*/

    // 所要時間変更時
    $(document).on('change', 'input[name^="time_required["]', function() {

        let modalId = '#drive_operation-work-setting-modal';
        let currentStartTime = new Date($(modalId + "-start_date_0").val());
        let elapsedTime = $('.before_time_required').val();
        let checkArr = elapsedTime.split(':');
        let sumElapsedTime = 0;
        let len = $('#edit-work').find('.card').length;
        let cnt = 1;

        $('#edit-work').find('.card').each(function (index, element) {
            // 開始日時を設定
            $(element).find('input[name="start_date[]"]').val(convertDate(currentStartTime));
            if(cnt < len) {
                let currentElapsedTime = $(element).find($(modalId + '-time_required_' + (cnt - 1))).val();
                let arr = currentElapsedTime.split(':');

                // 所要時間が元の時間を超えた場合はスキップ
                sumElapsedTime += (arr[0] * 60) + (arr[1] * 1);
                let elapsedMinutes = (checkArr[0] * 60) + (checkArr[1] * 1);
                if((sumElapsedTime > elapsedMinutes) || (sumElapsedTime < 0)){
                    return false;
                }

                // 終了日時を計算して設定
                currentStartTime.setHours(currentStartTime.getHours() + arr[0] * 1);
                currentStartTime.setMinutes(currentStartTime.getMinutes() + arr[1] * 1);
                $(element).find('input[name="end_date[]"]').val(convertDate(currentStartTime));
            }else {
                let startTime = new Date($(modalId + "-start_date_0").val());

                // 終了日時を計算して設定
                startTime.setHours(startTime.getHours() + checkArr[0] * 1);
                startTime.setMinutes(startTime.getMinutes() + checkArr[1] * 1);
                $(element).find('input[name="end_date[]"]').val(convertDate(startTime));

                // 残り所要時間の計算
                diff = moment(startTime).diff(convertDate(currentStartTime), 'minutes');

                let hour = Math.floor(diff / 60);
                let min = diff - hour * 60;

                $(modalId + '-time_required_' + (cnt - 1)).val(String(hour).padStart(2, '0') + ":" + String(min).padStart(2, '0'));
                $(element).find(modalId + '-time_required_' + (cnt - 1) + '-value').val(String(hour).padStart(2, '0') + ":" + String(min).padStart(2, '0'));
            }
            cnt++;
        })
    });

}

/**
 * 日報出力_荷待ち理由登録時のイベント設定
 */
window.drive_operation_shipper_event_set = function () {

    /*---- 更新ボタン押下時 ----*/

    // 更新ボタン押下時
    $(document).on('click', '#drive_operation-shipper-form-update', function () {
        let self = $(this);
        // 検索条件を配列化
        let params = ['id', 'holding_id', 'company_id', 'section_id', 'record_id', 'start_time', 'end_time', 'check_cnt'];
        let data = [];
        // データを追加
        params.forEach(function(param) {
            if (self.data(param) != null && self.data(param) != '' ) {
                data.push({'name' : param, 'value' : self.data(param)});
            }
        });
        // 待機イベントを追加
        for(i = 0; i < $(this).data('check_cnt'); i ++) {
            data.push({'name' : 'reason_' + i, 'value' : $('input:radio[name="reason_' + i + '"]:checked').val()});
            data.push({'name' : 'time_' + i, 'value' : $('#time_' + i).val()});
            data.push({'name' : 'keyid_' + i, 'value' : $('#keyid_' + i).val()});
        }
        // アクション取得
        action = self.data('action');
        url = _request.create_url(action, data);
        // POST
        _ajax.post(action, data, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- 一覧に戻るボタン押下時 ----*/

    // 一覧に戻るボタン押下時
    $(document).on('click', '#drive_operation-shipper-form-back', function () {
        let self = $(this);
        // 検索条件を配列化
        let params = ['id', 'holding_id', 'company_id', 'section_id', 'record_id', 'start_time', 'end_time', 'end_time_from', 'end_time_to', 'filter_holding_id', 'filter_company_id', 'filter_section_id'];
        let data = [];
        // データを追加
        params.forEach(function(param) {
            if (self.data(param) != null && self.data(param) != '' ) {
                data.push({'name' : param, 'value' : self.data(param)});
            }
        });
        // アクション取得
        action = self.data('action');
        url = _request.create_url(action, data);
        // 生成したURLへリダイレクト
        location.href = url;
    });
    
}

window.view_map = function (lat, lon, time, msg){
    var options = {
        latitude:   lat,       // 緯度
        longitude:  lon,      // 経度
        //radius:     radius,         // 半径
        mapZoom:    12,             // ズーム倍率
        time: time, // 吹き出し
        msg: msg, // 吹き出し
    };
    $("#menu_ZMap").mapCommon(options);
}

window.clear_map = function(){
    $("#menu_ZMap").empty();
}

/**
 * 日付を文字列に整形（yyyy/mm/dd H:i）
 *
 * @return
 */
window.convertDate = function(time){

    time = time.getFullYear()+'/'+( "0"+( time.getMonth()+1 ) ).slice(-2)+'/'+( "0"+time.getDate() ).slice(-2)
                    +' '+( "0"+( time.getHours() ) ).slice(-2)+':'+( "0"+( time.getMinutes() ) ).slice(-2);

    return time;
}
